import { render, staticRenderFns } from "./numbermanage.vue?vue&type=template&id=48b0908a&scoped=true&"
import script from "./numbermanage.vue?vue&type=script&lang=js&"
export * from "./numbermanage.vue?vue&type=script&lang=js&"
import style0 from "./numbermanage.vue?vue&type=style&index=0&id=48b0908a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0908a",
  null
  
)

export default component.exports